module.exports = __webpack_public_path__ + "img/6.cb52dcc0.png";